import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=498fd5d0&"
import script from "./Receipt.vue?vue&type=script&lang=ts&"
export * from "./Receipt.vue?vue&type=script&lang=ts&"
import style0 from "./Receipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports